import { createSlice } from "@reduxjs/toolkit"

const creativeGroupingSlice = createSlice({
  name: "creativeGrouping",
  initialState: {
    groupedCreatives: null,
    groupCreativesLoading: false,
    ungroupCreativesLoading: false,
  },
  reducers: {
    groupCreativesLoading: (state) => {
      state.groupCreativesLoading = true
    },
    groupCreativesSuccess: (state, action) => {
      state.groupedCreatives = action.payload
      state.groupCreativesLoading = false
    },
    groupCreativesFailure: (state) => {
      state.groupCreativesLoading = false
    },
    ungroupCreativesLoading: (state) => {
      state.ungroupCreativesLoading = true
    },
    ungroupCreativesSuccess: (state) => {
      state.groupedCreatives = null
      state.ungroupCreativesLoading = false
    },
    ungroupCreativesFailure: (state) => {
      state.ungroupCreativesLoading = false
    },
  },
})

export const {
  groupCreativesLoading,
  groupCreativesSuccess,
  groupCreativesFailure,
  ungroupCreativesLoading,
  ungroupCreativesSuccess,
  ungroupCreativesFailure,
} = creativeGroupingSlice.actions

export default creativeGroupingSlice.reducer
